/** Station and brakes are arc-length ranges painted onto the track. */
export type Section =
  | { kind: 'station'; from: number; to: number }
  | { kind: 'brake'; from: number; to: number; target: number; decel: number };

export type SectionKind = Section['kind'];

/** Is arc length s inside the [from, to] range, handling closed-track wraparound? */
export function inRange(s: number, from: number, to: number, totalLength: number, closed: boolean): boolean {
  if (from <= to) return s >= from && s <= to;
  if (!closed) return false;
  return s >= from || s <= to; // range wraps past s = 0
}

export function sectionsAt(sections: Section[], s: number, totalLength: number, closed: boolean): Section[] {
  return sections.filter((sec) => inRange(s, sec.from, sec.to, totalLength, closed));
}

export function firstSectionOfKind<K extends SectionKind>(
  sections: Section[],
  kind: K,
): Extract<Section, { kind: K }> | undefined {
  return sections.find((s): s is Extract<Section, { kind: K }> => s.kind === kind);
}
